import { render, staticRenderFns } from "./software.vue?vue&type=template&id=5b813a74&scoped=true"
var script = {}
import style0 from "./software.vue?vue&type=style&index=0&id=5b813a74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b813a74",
  null
  
)

export default component.exports